import React, { createRef , useEffect, useState } from "react";
import { Col, Input, Row, Spinner, UncontrolledTooltip } from "reactstrap";
import { getExtentionFile, isImageFile } from "../helpers/utility";
import Dropzone from "react-dropzone";
import moment from "moment";
import ApiRequest from "../helpers/api_server";
import DropDownAlert from "./DropDownAlert";
import ModalDocumentHistory from "./ModalDocumentHistory";
import ModalValidationCheck from "./ModalValidationCheck";
import { STATUS_REASONS } from "../constants/status";
import {store} from "../redux/store";
import { USER_ACCESS } from "../constants/access";

function UploadFile({
    id,
    disableEdit,
    handleAcceptedFiles,
    typeFile,
    file,
    titleDocument,
    showPreviewImage,
    processUpload,
    identity,
    customerId = "",
    loanId = "",
    isShowCheck = false,
    typeReason = ""
}) {
    const { user } = store.getState().Auth;
    const [firstFetch , setFirstFetch] = useState(false)
    const [listReason , setListReason] = useState([])
    const [documenCheck, setdocumenCheck] = useState(null)
    const [isLoading, setisLoading] = useState(true)
    const [reason , setReason] = useState("belum")
    const [openModal, setOpenModal] = useState(false)
    const [formReason, setFormReason] = useState(false)
    const [description, setDescription] = useState(false)

    const dropzoneRef = createRef();
    const openDialog = () => {
        if (dropzoneRef.current) {
            dropzoneRef.current.open();
        }
    };

    const download = (file) => {
        fetch(file, {
            method: "GET",
            headers: {},
        })
            .then((response) => {
                response.arrayBuffer().then(function (buffer) {
                    const url = window.URL.createObjectURL(new Blob([buffer]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `${identity.replaceAll(" ", "-")}-${typeFile.replaceAll("_", "-")}-${moment().format(
                            "YYYY-MM-DD"
                        )}.${getExtentionFile(file)}`
                    );
                    document.body.appendChild(link);
                    link.click();
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    async function getReasonList() {
        try {
            const data = await ApiRequest.get(`/options/customer/validation/status/${typeReason}`);
            setListReason(data?.data ?? [])
        } catch (error) {
            DropDownAlert.show("danger", `[ktp]:  ${error}`);
        }
    }

    async function handleReasonDocument(reasonId){
        const formData = {
            validation_status_id : reasonId,
            loan_id : loanId ,
            customer_id : customerId,
            key : typeReason
        }
        setFormReason(formData)
    }

    async function handleGetDocument(){
        try {
            const data = await ApiRequest.get(`/customer/validation/${loanId}/type/${typeReason}`)
            setdocumenCheck(data?.data)
            setTimeout(() => {
                setReason(
                    data?.data?.is_valid
                      ? 79
                      : data?.data?.validation_status_id
                  );
                setisLoading(false)
            }, 1200);
        } catch (error) {
            DropDownAlert.show("danger", `[get document]: ${error}`);
        }
    }

    async function handleValidateCheck(){
        const formData = {
            loan_id : loanId ,
            customer_id : customerId,
            validation_status_id : STATUS_REASONS.APPROVE,
            key : typeReason,
        }
        setFormReason(formData)
    }

    const handleChangeReason = (e) => {
        const { value } = e.target;

        if (Number(value) === STATUS_REASONS.APPROVE) {
            setDescription("Dokumen Tervalidasi")
            handleValidateCheck();
        }

        if (
            ![STATUS_REASONS.APPROVE].includes(Number(value))
        ) {
            setDescription(getDescription(Number(value)))
            handleReasonDocument(Number(value));
        }
    };

    const handleResetModal = () => {
        handleGetDocument()
        setFormReason(null)
    }

    const getDescription = (id) => {
        if (id === STATUS_REASONS.APPROVE) {
          return "Dokumen Tervalidasi";
        }
    
        if (id !== STATUS_REASONS.APPROVE) {
          return listReason?.find((item) => item.id === id)?.description;
        }
        return "";
      };

    
    useEffect(() => {
        if(isShowCheck && typeReason !== ""){
            if(!firstFetch){
                setFirstFetch(true)
                getReasonList()
                handleGetDocument()
            }
        }
    } , [])

    return (
        <Dropzone
            ref={dropzoneRef}
            noClick
            noKeyboard
            onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles, typeFile)}>
            {({ getRootProps, getInputProps }) => (
                <>
                    <div
                        {...getRootProps({ className: "dropzone", id: id })}
                        style={{ backgroundColor: disableEdit ? "#f4f4f4" : "#ffffff" }}>
                        <input
                            {...getInputProps()}
                            id={titleDocument.toLowerCase().split(" ").join("-").replace(/[/]/g, "")}
                        />
                        <div className="p-1 px-2">
                            <Row className="align-items-center">
                                <Col className="col-auto">
                                    <div className="avatar-sm font-weight-bold mr-3">
                                        <span className="avatar-title rounded bg-soft-primary text-primary">
                                            {file ? (
                                                <i
                                                    className={`${
                                                        isImageFile(file) ? "uil-scenery" : "uil-file-alt"
                                                    } font-size-20`}></i>
                                            ) : (
                                                <i className="uil-folder-upload font-size-20"></i>
                                            )}
                                        </span>
                                    </div>
                                </Col>
                                <Col className="pl-0">
                                    
                                    <span className="text-muted font-weight-bold">
                                        {titleDocument}
                                    </span>
                                    
                                    <p className="mb-0">format file: {file ? getExtentionFile(file) : "-"}</p>
                                    {
                                        (!disableEdit && (typeFile == 'ktp' || typeFile == 'selfie_ktp' || typeFile == 'ro_ktp' || typeFile == 'ro_selfie_ktp')) && (
                                            <ul className='m-0 pl-3'>
                                                <li><small className="mb-0">{ `Format foto harus berupa JPG/JPEG` }</small></li>
                                                <li><small className="mb-0">{ `Ukuran maksimal foto 1 MB` }</small></li>
                                            </ul>
                                        )
                                    }
                                   {!disableEdit &&
                                        (typeFile == "coe" ||
                                        typeFile == "selfie_contract_document" ||
                                        typeFile == "employment_contract_document" ||
                                        typeFile == "ro_employment_contract_document" ||
                                        typeFile == "ro_membership_application_document") && (
                                        <ul className="m-0 pl-3">
                                            <li>
                                            <small className="mb-0">{`Format dokumen harus berupa PDF`}</small>
                                            </li>
                                        </ul>
                                    )}
                                </Col>
                                <Col className="col-auto">
                                    {processUpload && processUpload === typeFile && (
                                        <Spinner color={"#369378"} size="sm" className="mr-2" />
                                    )}
                                    {!processUpload && !disableEdit && (
                                        <div className="d-flex">
                                            <div>
                                                <a
                                                    id={`btn-dl-${id}`}
                                                    className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                    onClick={openDialog}>
                                                    <i className="uil uil-upload-alt font-size-20"></i>
                                                </a>
                                                <UncontrolledTooltip placement="bottom" target={`btn-dl-${id}`}>
                                                    Unggah Dokumen
                                                </UncontrolledTooltip>
                                            </div>
                                        </div>
                                    )}
                              
                                    <div>
                                        {file && !processUpload && disableEdit && isImageFile(file) && (
                                            <div className="d-flex">
                                                {isShowCheck && documenCheck?.updated_by !== null && (
                                                    <div>
                                                        <a
                                                            className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                            onClick={() => setOpenModal(true)}
                                                        >
                                                            <i className="uil uil-clock font-size-20"></i>
                                                        </a>
                                                    </div>
                                                )}
                                                <div>
                                                    <button
                                                        className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                        id={`btn-d-${id}`}
                                                        href="#"
                                                        onClick={() => download(file)}>
                                                        <i className="uil uil-cloud-download font-size-20"></i>
                                                    </button>
                                                </div>
                                                <div>
                                                    <a
                                                        className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                        id={`btn-d-${id}`}
                                                        onClick={showPreviewImage}>
                                                        <i className="uil uil-eye font-size-20"></i>
                                                    </a>
                                                    <UncontrolledTooltip placement="bottom" target={`btn-d-${id}`}>
                                                        Lihat Dokumen
                                                    </UncontrolledTooltip>
                                                </div>
                                            </div>
                                        )}
                                        {file && !processUpload && disableEdit && !isImageFile(file) && (
                                            <div className="d-flex">
                                                {isShowCheck && documenCheck?.updated_by !== null && (
                                                    <div>
                                                        <a
                                                            className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                            onClick={() => setOpenModal(true)}
                                                        >
                                                            <i className="uil uil-clock font-size-20"></i>
                                                        </a>
                                                    </div>
                                                )}
                                                <div>
                                                    <button
                                                        className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                        id={`btn-d-${id}`}
                                                        href="#"
                                                        onClick={() => download(file)}>
                                                        <i className="uil uil-cloud-download font-size-20"></i>
                                                    </button>
                                                </div>
                                                <div>
                                                    <a
                                                        href={file}
                                                        target="_blank"
                                                        className="btn btn-link text-primary btn-lg p-0 ml-1"
                                                        id={`btn-d-${id}`}>
                                                        <i className="uil uil-eye font-size-20"></i>
                                                    </a>
                                                    <UncontrolledTooltip placement="bottom" target={`btn-d-${id}`}>
                                                        Lihat Dokumen
                                                    </UncontrolledTooltip>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    
                                </Col>
                            </Row>
                        </div>

                        {!isLoading && (
                        <div>
                            {/* Validasi Reason Select is available*/}
                            {isShowCheck === true && file && documenCheck && (
                            <div className="pt-1 pb-3 px-3">
                                 <div className="d-flex flex-row gap-4 align-items-center mb-2">
                                    <div className="flex-1" style={{flex : 1}}>
                                        <Input
                                        type="select"
                                        name="select"
                                        id="work_field"
                                        onChange={handleChangeReason}
                                        value={reason}
                                        defaultValue={reason}
                                        style={{ backgroundColor: "#ffffff" }}
                                        >
                                        <option value={"belum"}>Dokumen belum tervalidasi</option>
                                        {listReason.map((item, idx) => (
                                            <option key={idx} value={item.id}>
                                            {item.description}
                                            </option>
                                        ))}
                                        <option value={STATUS_REASONS.APPROVE}>Dokumen Tervalidasi</option>
                                       
                                        </Input>
                                    </div>
                                </div>
                               
                                {documenCheck && documenCheck?.validation_status_id && (
                                    <div className="d-flex flex-row" style={{ gap: 12 }}>
                                        {documenCheck?.updated_time && (
                                        <div
                                            className="d-flex flex-row align-items-center gap-4"
                                            style={{ gap: 8 }}
                                        >
                                            <i
                                            id="btn-d-u"
                                            className="uil uil-clock font-size-20 text-primary"
                                            ></i>
                                            <span className="">
                                            {moment(documenCheck?.updated_time).format(
                                                "DD-MMM-YYYY HH:mm"
                                            )}
                                            </span>
                                            <UncontrolledTooltip
                                            placement="bottom"
                                            target={`btn-d-u`}
                                            >
                                            Waktu Update
                                            </UncontrolledTooltip>
                                        </div>
                                        )}

                                        {documenCheck?.updated_time && (
                                        <div
                                            className="d-flex flex-row align-items-center gap-4"
                                            style={{ gap: 8 }}
                                        >
                                            <i className="uil uil-user-check font-size-20 text-primary"></i>
                                            <span id="btn-d-t" className="">
                                            {documenCheck?.updated_by ?? "-"}
                                            </span>
                                            <UncontrolledTooltip
                                            placement="bottom"
                                            target={`btn-d-t`}
                                            >
                                            Nama Update
                                            </UncontrolledTooltip>
                                        </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            )}

                            {/* Validasi Reason Select is not available*/}
                            {isShowCheck === true && file && !documenCheck && (
                            <div className="pt-1 pb-3 px-3">
                                <div className="d-flex flex-row gap-4 align-items-center">
                                    <div className="flex-1" style={{flex : 1}}>
                                        <Input
                                        type="select"
                                        name="select"
                                        id="work_field"
                                        disabled={!disableEdit}
                                        value={reason}
                                        defaultValue={reason}
                                        onChange={handleChangeReason}
                                        style={{ backgroundColor: "#ffffff" }}
                                        >
                                        <option value={"belum"}>Dokumen belum tervalidasi</option>
                                        {listReason.map((item, idx) => (
                                            <option key={idx} value={item.id}>
                                            {item.description}
                                            </option>
                                        ))}
                                         <option value={STATUS_REASONS.APPROVE}>Dokumen Tervalidasi</option>
                                        </Input>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                        )}
                    </div>
                    {openModal && documenCheck && (
                        <ModalDocumentHistory
                        customerId={documenCheck?.customer_validation_id}
                        resetModal={() => setOpenModal(false)}
                        />
                    )}
                    { formReason && (
                        <ModalValidationCheck
                        formReason={formReason}
                        setReason={setReason}
                        resetModal={handleResetModal}
                        description={description}
                        titleDoc={titleDocument}
                        />
                    )}
                </>
            )}

        </Dropzone>
    );
}

export default UploadFile;
